<template>
    <span>
        <div v-if="Array.isArray(data)" >
            <div v-for="(elem, idx) in data" :key="idx">
                <b-container v-show="idx >= page && idx < page + 10" style="margin: 0; padding: 0; max-width: none;" fluid>
                    <b-row>
                        <b-col :cols="1">
                            <span :style="'color:' + ((action_columns_picking && action_columns_picking.hasOwnProperty(index) && action_columns_picking[index].idx.includes(idx)) ? 'green' : 'black')">{{idx + 1}}</span>
                            <b-button :style="'color:' + ((action_columns_picking && action_columns_picking.hasOwnProperty(index) && action_columns_picking[index].idx.includes(idx)) ? 'green' : 'black')" variant="link" v-if="level == 1" @click="get(elem, idx, id_parent + ' ' + idx)"><i class="fas fa-plus"></i></b-button>
                        </b-col>
                        <b-col>
                            <json_editor_value :multiple="multiple" :config_columns="config_columns" :action_columns_picking="action_columns_picking" :id_parent="id_parent + ' ' + idx" :id_action="id_action" :data="elem" :level="level + 1" @get="get" :index="index"/>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <b-button @click="page -= 10" variant="link" v-show="page != 0">Résultats précédents</b-button>
            <b-button @click="page += 10" variant="link" v-show="data.length > 10 + page">Résultats suivants</b-button>
        </div>
        <div v-else-if="typeof data == 'object'" >
            <div style="padding-left:10px" v-for="(elem, key, idx) in data" :key="key">
                <span v-if="config_columns[key] && config_columns[key].type == 'image'">
                    <b>{{ key }}</b> : {{elem}}<br />
                    <img :src="elem" :style="'max-height: 200px'" />
                </span>
                <span v-else>
                    <b>{{ key }}</b> : <json_editor_value :multiple="multiple" :config_columns="config_columns" :action_columns_picking="action_columns_picking" :id_parent="id_parent + ' ' + idx" :id_action="id_action" :data="elem" :level="level + 1" @get="get" :index="index"/>
                </span>
            </div>
        </div>
        <span v-else>
            <span>{{ data }}</span>
            <!-- <b-button size="sm" :style="'color:' + ((action_columns_picking && action_columns_picking.hasOwnProperty(index) && action_columns_picking[index].idx == '0') ? 'green' : 'black')" variant="link" @click="get(data, '0', id_parent + ' 0')"><i class="fas fa-plus"></i></b-button> -->
        </span>
    </span>
</template>

<script>
    import uniqueId from "lodash.uniqueid";
	import draggable from "vuedraggable";

    import store from "../store";

	var clone = require("clone");

    export default {
        name: "json_editor_value",
        components: {
            draggable
        },
        props: {
            data: {},
            level: {},
            id_action: {},
            id_parent: {
                default: ""
            },
            action_columns_picking: {
                default: () => {}
            },
            config_columns: {
                default: () => {}
            },
            multiple: {
                default: false
            },
            index: {},
        },
        data: function () {
            return {
                id: uniqueId(),
                page: 0
            };
		},
        watch: {
            data: {
                deep: true,
                async handler() {
                    this.page = 0;
                }
            }
        },
		methods: {
            get(elem, idx, id)
            {
                this.$emit("get", elem, idx, id, this.multiple);
            }
        },
		mounted: function () {
		}
    }

</script>